import { FeatureToggle, useUnleashFlags } from '../utils/useUnleashFlags';

import { AllSignedInRoutes } from './types';

type RouteOptions<ParamList, RouteName extends keyof ParamList> = RouteName extends unknown
  ? {
      name: RouteName;
      key?: string;
      params: ParamList[RouteName];
      merge?: boolean;
    }
  : never;

export const useInitialRouteName = () => {
  const { b2bShowModuleHome } = useUnleashFlags(FeatureToggle.Home);

  if (b2bShowModuleHome) {
    return { name: 'Home' } as RouteOptions<AllSignedInRoutes, 'Home'>;
  }

  return {
    name: 'AngularFrame_Home',
    params: {
      state: 'new-app.home',
    },
  } as RouteOptions<AllSignedInRoutes, 'AngularFrame_Home'>;
};
